module.exports = __webpack_public_path__ + "assets/img/thumb-The-Dream-Collective-Website.bc30c028.jpg";